import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyCustomQuickorderFlyoutComponent } from './lazy-custom-quickorder-flyout/lazy-custom-quickorder-flyout.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'customQuickorder',
        location: () => import('../store/custom-quickorder-store.module').then(m => m.CustomQuickorderStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyCustomQuickorderFlyoutComponent],
  exports: [LazyCustomQuickorderFlyoutComponent],
})
export class CustomQuickorderExportsModule {}
